import {
  ButtonCheckbox,
  IconPonticModifiedRidge,
  IconPonticOvate,
  IconPonticSaddle,
  SaveableCard,
} from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getFixedPreferenceDefaults } from "../fixedPreferenceForm";

const BRIDGE_MATERIALS = [
  "Céramique sur zircone",
  "Full zircone",
  "Zircone multicouche",
  "e.max",
  "Céramo-métallique",
];
const BRIDGE_TYPES = ["Classique", "Cantilever", "Maryland"];
const PONTIC_SHAPES = [
  {
    label: "Pontique en selle",
    icon: <IconPonticSaddle size={28} />,
    description: "Épouse toute la crête. Stable, mais difficile à nettoyer.",
  },
  {
    label: "Pontique crête modifiée",
    icon: <IconPonticModifiedRidge size={28} />,
    description:
      "Contact vestibulaire uniquement. Bon compromis entre esthétique et hygiène.",
  },
  {
    label: "Pontique ovoïde",
    icon: <IconPonticOvate size={28} />,
    description:
      "Arrondi, s'enfonce dans une crête préparée. Le plus esthétique.",
  },
];
const CERAMIC_GINGIVA = ["Non", "Oui"];

export const BridgePreferences = withForm({
  defaultValues: getFixedPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "bridgeMaterial",
      "bridgeType",
      "ponticShape",
      "ceramicGingiva",
    ]);

    return (
      <SaveableCard
        title="Bridges"
        description="Matériau, embase et gencive"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Matériau du bridge</Text>
              <form.Field name="bridgeMaterial">
                {field => (
                  <Select
                    data={BRIDGE_MATERIALS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Type de bridge</Text>
              <form.Field name="bridgeType">
                {field => (
                  <Select
                    data={BRIDGE_TYPES}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Group gap="s1">
              <Text variant="strong">Forme du pontique</Text>
              <Text variant="strong" fw="400" c="var(--mantine-color-ink-4)">
                sous la dent remplacée
              </Text>
            </Group>
            <form.Field name="ponticShape">
              {field => {
                const selectedShape = PONTIC_SHAPES.find(
                  shape => shape.label === field.state.value
                );

                return (
                  <>
                    <Group>
                      {PONTIC_SHAPES.map(shape => (
                        <ButtonCheckbox
                          key={shape.label}
                          id={shape.label}
                          leftSection={shape.icon}
                          isActive={field.state.value === shape.label}
                          onClick={() => field.handleChange(shape.label)}
                        >
                          {shape.label}
                        </ButtonCheckbox>
                      ))}
                    </Group>
                    {selectedShape && (
                      <Text
                        c="var(--mantine-color-ink-5)"
                        variant="strong"
                        fw="400"
                      >
                        {selectedShape.label} : {selectedShape.description}
                      </Text>
                    )}
                  </>
                );
              }}
            </form.Field>
          </>
          <>
            <Text variant="strong">Gencive céramique</Text>
            <form.Field name="ceramicGingiva">
              {field => (
                <Group>
                  {CERAMIC_GINGIVA.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
